export default (async function showResults() {
  window.onbeforeunload = undefined;
  document.getElementsByTagName("form")[0].submit()
});
